import { emptyField, fieldTooShort } from '@/lib/validation/ErrorMessages'
import * as Yup from 'yup'

export const password = Yup.string().min(6, fieldTooShort).required(emptyField)

export default password
